export { Card } from './ui/card/Card';
export { ProductCardSkeleton } from './ui/card/ProductCardSkeleton';
export type { Product, Products, ProductCatalogResponse } from './config/types';
export { getProductOneData } from './api/productOneApi';
export { getProductCatalogData } from './api/productCatalogApi';
export {
  useProductOneData,
  useProductCatalogData,
  productPageQueryKeys,
  catalogQueryOptions,
} from './model/queries';
